module.exports = __webpack_public_path__ + "static/media/PillsImg3.2494d633.jpg";